import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import {
    addAbout,
    deleteAbout,
    getAbout,
    updateAbout,
} from '../../../redux/actions/Master.action';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';

export default function AboutData() {
    const [show, setShow] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [ids, setIds] = useState(null);
    const [logoName, setLogoName] = useState('');
    const [signatureName, setSignatureName] = useState('');
    const [initialValues, setInitialValues] = useState({
        name: '',
        gstIn: '',
        panNo: '',
        address: '',
        mobileNumber: '',
        telephoneNumber: '',
        // logo: '',
        // signature: '',
    });

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        gstIn: Yup.string().required('GST is required'),
        panNo: Yup.string().required('PAN no is required'),
        address: Yup.string().required('Address is required'),
        mobileNumber: Yup.string().required('Mobile Number is required'),
        telephoneNumber: Yup.string().required('Telephone Number is required'),
        // logo: Yup.string().required('Logo is required'),
        // signature: Yup.string().required('Signature is required'),
    });
    const toggle = () => {
        setShow(!show);
    };
    const updateToggle = () => {
        setUpdateModal(!updateModal);
    };
    const deleteToggle = () => {
        setDeleteModal(!deleteModal);
    };

    const dispatch = useDispatch();
    const hsnData = useSelector((state) => state.master);

    const [formData, setFormData] = useState({
        name: '',
        gstIn: '',
        panNo: '',
        address: '',
        mobileNumber: '',
        telephoneNumber: '',
        logo: '',
        signature: '',
    });

    const handleAddHsn = (values, { resetForm }) => {
        const formDatas = new FormData();
        for (const key in values) {
            if (key === 'logo' || key === 'signature') {
                formDatas.append(key, values[key] instanceof File ? values[key] : null);
            } else {
                formDatas.append(key, values[key]);
            }
        }
        dispatch(addAbout(formDatas)).then(() => {
            toggle();
            resetForm();
        });
    };

    const handleUpadteHsn = (values) => {
        const formData = new FormData();

        formData.append('name', values.name);
        formData.append('gstIn', values.gstIn);
        formData.append('panNo', values.panNo);
        formData.append('address', values.address);
        formData.append('mobileNumber', values.mobileNumber);
        formData.append('telephoneNumber', values.telephoneNumber);

        if (values.logo) {
            formData.append('logo', values.logo);
        }
        if (values.signature) {
            formData.append('signature', values.signature);
        }

        dispatch(updateAbout(formData, ids)).then(() => {
            setUpdateModal(false);
        });
    };


    const handleDeleteHsn = () => {
        dispatch(deleteAbout(ids)).then(() => {
            deleteToggle();
        });
    };

    useEffect(() => {
        dispatch(getAbout());
    }, []);

    useEffect(() => {
        if (formData.logo) setLogoName(formData.logo || '');
        if (formData.signature) setSignatureName(formData.signature || '');
    }, [formData]);


    return (
        <>
            <div className="mt-[100px] d-flex justify-content-end">
                <div className="d-flex items-center gap-3">
                    <Button
                        onClick={toggle}
                        className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                    >
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Info
                    </Button>
                </div>
            </div>
            <div className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between mt-5'>
                    <h3 className="fw-bold">About</h3>
                </div>
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Name</Th>
                                <Th>GSTN</Th>
                                <Th>PAN</Th>
                                <Th>ADDRESS</Th>
                                <Th>PHONE NUMBER</Th>
                                <Th>TELEPHONE NUMBER </Th>
                                <Th>LOGO</Th>
                                <Th>SIGNATURE</Th>
                                <Th className="text-end">Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {hsnData?.getAbout?.data?.data?.length > 0 ? (
                                hsnData?.getAbout?.data?.data?.map((res) => {
                                    return (
                                        <Tr key={res._id}>
                                            <Td>{res.name}</Td>
                                            <Td>{res.gstIn}</Td>
                                            <Td>{res.panNo}</Td>
                                            <Td>{res.address}</Td>
                                            <Td>{res.mobileNumber}</Td>
                                            <Td>{res.telephoneNumber}</Td>
                                            <Td><img src={res.logo} className='' /></Td>
                                            <Td><img src={res.signature} className='' /></Td>
                                            <Td style={{ minWidth: '200px' }}>
                                                <div className="d-flex gap-3 justify-end">
                                                    <FaEdit
                                                        onClick={() => {
                                                            updateToggle();
                                                            setFormData(res);
                                                            setIds(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-success"
                                                        title="update"
                                                    />
                                                    <MdDelete
                                                        onClick={() => {
                                                            deleteToggle();
                                                            setIds(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-danger"
                                                        title="delete"
                                                    />
                                                </div>
                                            </Td>
                                        </Tr>
                                    );
                                })
                            ) : (
                                <>
                                    <Tr>
                                        <Td colSpan={9} textAlign="center">
                                            Batch Not Found
                                        </Td>
                                    </Tr>
                                </>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>

            {/* add HSN */}

            <Modal show={show} onHide={toggle} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Add Info</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleAddHsn}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('name', e.target.value)
                                                }
                                                value={values.name}
                                                placeholder="Enter Name"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="name"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>GSTN</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="gstIn"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('gstIn', e.target.value)
                                                }
                                                value={values.gstIn}
                                                placeholder="Enter GST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="gstIn"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>PAN</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="panNo"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('panNo', e.target.value)
                                                }
                                                value={values.panNo}
                                                placeholder="Enter PAN"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="panNo"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Address</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="address"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('address', e.target.value)
                                                }
                                                value={values.address}
                                                placeholder="Enter Address"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="address"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="mobileNumber"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('mobileNumber', e.target.value)
                                                }
                                                value={values.mobileNumber}
                                                placeholder="Enter Phone Number"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="mobileNumber"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Telephone Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="telephoneNumber"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('telephoneNumber', e.target.value)
                                                }
                                                value={values.telephoneNumber}
                                                placeholder="Enter Telephone Number"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="telephoneNumber"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Logo</Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="logo"
                                                onChange={(e) => setFieldValue('logo', e.target.files[0])}
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="logo"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Signature</Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="signature"
                                                onChange={(e) => setFieldValue('signature', e.target.files[0])}
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="signature"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* update HSN */}

            <Modal show={updateModal} onHide={updateToggle} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Update Info</Modal.Title>
                </Modal.Header>

                <Formik
                    enableReinitialize={true}
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpadteHsn}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('name', e.target.value)
                                                }
                                                value={values.name}
                                                placeholder="Enter Name"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="name"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>GSTN</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="gstIn"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('gstIn', e.target.value)
                                                }
                                                value={values.gstIn}
                                                placeholder="Enter GST"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="gstIn"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>PAN</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="panNo"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('panNo', e.target.value)
                                                }
                                                value={values.panNo}
                                                placeholder="Enter PAN"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="panNo"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Address</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="address"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('address', e.target.value)
                                                }
                                                value={values.address}
                                                placeholder="Enter Address"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="address"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="mobileNumber"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('mobileNumber', e.target.value)
                                                }
                                                value={values.mobileNumber}
                                                placeholder="Enter Phone Number"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="mobileNumber"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Telephone Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="telephoneNumber"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('telephoneNumber', e.target.value)
                                                }
                                                value={values.telephoneNumber}
                                                placeholder="Enter Telephone Number"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="telephoneNumber"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Logo</Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="logo"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    setFieldValue('logo', file);
                                                    if (file) {
                                                        setLogoName(URL.createObjectURL(file));
                                                    } else {
                                                        setLogoName('');
                                                    }
                                                }}
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            {logoName && (
                                                <div className="text-muted mt-1">
                                                    Selected File: <img src={logoName} className="w-[100px]" alt="logo preview" />
                                                </div>
                                            )}
                                            <ErrorMessage name="logo" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>

                                    <div className="col-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Signature</Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="signature"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    setFieldValue('signature', file);
                                                    if (file) {
                                                        setSignatureName(URL.createObjectURL(file));
                                                    } else {
                                                        setSignatureName('');
                                                    }
                                                }}
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            {signatureName && (
                                                <div className="text-muted mt-1">
                                                    Selected File: <img src={signatureName} className="w-[100px]" alt="signature preview" />
                                                </div>
                                            )}
                                            <ErrorMessage name="signature" component="div" className="text-danger" />
                                        </Form.Group>
                                    </div>

                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button type="submit" className="!bg-theme-dark border-0 px-4">
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete HSN */}

            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className="p-5">
                    <div>
                        <PiWarningCircleBold className="text-7xl w-100 text-danger" />
                    </div>
                    <div className="text-center mt-4">
                        <h3>Are You Sure ?</h3>
                        <p className="text-md">
                            Do you really want to delete these records?
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDeleteHsn}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
